module.exports = __webpack_public_path__ + "static/media/FENGYUN 3B.b1e11557.czml";